export const SET_CONFIGURATIONS = 'SET_CONFIGURATIONS'
export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION'
export const REMOVE_CONFIGURATION = 'REMOVE_CONFIGURATION'

export const SET_ACTIVE_CONFIGURATIONS = 'SET_ACTIVE_CONFIGURATIONS'
export const UPDATE_ACTIVE_CONFIGURATION = 'UPDATE_ACTIVE_CONFIGURATION'
export const REMOVE_ACTIVE_CONFIGURATION = 'REMOVE_ACTIVE_CONFIGURATION'